module.exports = __webpack_public_path__ + "img/default-search.a0e186680d56ce9bed78d3a7bc5448ad.jpg";